import { render } from "./CreateRoutes.vue?vue&type=template&id=0ff3ac04"
import script from "./CreateRoutes.vue?vue&type=script&lang=js"
export * from "./CreateRoutes.vue?vue&type=script&lang=js"

import "./CreateRoutes.vue?vue&type=style&index=0&id=0ff3ac04&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__